import { z } from "zod";

export enum StediEligibilityStatusValue {
  ACTIVE = "active",
  INACTIVE = "inactive",
  UNKNOWN = "unknown",
  FAILED = "failed",
}

// Keep existing wire DTO string types while deriving validation from the owning enum.
export const stediEligibilityStatusSchema: z.ZodType<`${StediEligibilityStatusValue}`> =
  z.enum(StediEligibilityStatusValue);

export type StediEligibilityStatus = z.infer<typeof stediEligibilityStatusSchema>;
